export function getEmployeeLeaveRowAction(status) {
  const normalized = status?.toUpperCase();
  if (normalized === "PENDING") return "withdraw";
  if (normalized === "APPROVED") return "revoke";
  return null;
}
